import { useEffect } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import Services from "@/components/site/Services";
import MaterialsMarquee from "@/components/site/MaterialsMarquee";
import Process from "@/components/site/Process";
import BookCall from "@/components/site/BookCall";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";

export default function LandingPage() {
  useEffect(() => {
    document.title = "Laser Cutting & Engraving — Southern Californiaf";
  }, []);

  return (
    <div className="min-h-screen bg-zinc-950 text-white" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <TrustStrip />
        <Services />
        <MaterialsMarquee />
        <Process />
        <BookCall />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
